import {
    FETCH_COMMISSION_RULES_REQUEST,
    FETCH_COMMISSION_RULES_SUCCESS,
    FETCH_COMMISSION_RULES_FAILURE,
    CREATE_COMMISSION_RULE_REQUEST,
    CREATE_COMMISSION_RULE_SUCCESS,
    CREATE_COMMISSION_RULE_FAILURE,
    UPDATE_COMMISSION_RULE_REQUEST,
    UPDATE_COMMISSION_RULE_SUCCESS,
    UPDATE_COMMISSION_RULE_FAILURE,
    DELETE_COMMISSION_RULE_REQUEST,
    DELETE_COMMISSION_RULE_SUCCESS,
    DELETE_COMMISSION_RULE_FAILURE,
} from "./types";

import {
    fetchCommissionRules,
    createCommissionRule,
    updateCommissionRule,
    deleteCommissionRule,
} from "../../services/commissionRuleService";


export const fetchCommissionRulesRequest = () => ({
    type: FETCH_COMMISSION_RULES_REQUEST,
});

export const fetchCommissionRulesSuccess = (data) => ({
    type: FETCH_COMMISSION_RULES_SUCCESS,
    payload: data,
});

export const fetchCommissionRulesFailure = (error) => ({
    type: FETCH_COMMISSION_RULES_FAILURE,
    payload: error,
});

export const fetchCommissionRulesAction =
    () => async (dispatch) => {
        dispatch(fetchCommissionRulesRequest());

        try {
            const response =
                await fetchCommissionRules();

            if (response.success) {
                dispatch(
                    fetchCommissionRulesSuccess(
                        response.data
                    )
                );

                return response;
            }

            dispatch(
                fetchCommissionRulesFailure(
                    response.error
                )
            );

            return response;
        } catch (error) {
            dispatch(
                fetchCommissionRulesFailure(
                    error.message
                )
            );

            return {
                success: false,
                error: error.message,
            };
        }
    };


export const createCommissionRuleRequest = () => ({
    type: CREATE_COMMISSION_RULE_REQUEST,
});

export const createCommissionRuleSuccess = (
    rule
) => ({
    type: CREATE_COMMISSION_RULE_SUCCESS,
    payload: rule,
});

export const createCommissionRuleFailure = (
    error
) => ({
    type: CREATE_COMMISSION_RULE_FAILURE,
    payload: error,
});

export const createCommissionRuleAction =
    (payload) => async (dispatch) => {
        dispatch(createCommissionRuleRequest());

        try {
            const response =
                await createCommissionRule(
                    payload
                );

            if (response.success) {
                dispatch(
                    createCommissionRuleSuccess(
                        response.data
                    )
                );

                return response;
            }

            dispatch(
                createCommissionRuleFailure(
                    response.error
                )
            );

            return response;
        } catch (error) {
            dispatch(
                createCommissionRuleFailure(
                    error.message
                )
            );

            return {
                success: false,
                error: error.message,
            };
        }
    };


export const updateCommissionRuleRequest = () => ({
    type: UPDATE_COMMISSION_RULE_REQUEST,
});

export const updateCommissionRuleSuccess = (
    rule
) => ({
    type: UPDATE_COMMISSION_RULE_SUCCESS,
    payload: rule,
});

export const updateCommissionRuleFailure = (
    error
) => ({
    type: UPDATE_COMMISSION_RULE_FAILURE,
    payload: error,
});

export const updateCommissionRuleAction =
    (
        commissionRuleId,
        payload
    ) =>
    async (dispatch) => {
        dispatch(
            updateCommissionRuleRequest()
        );

        try {
            const response =
                await updateCommissionRule(
                    commissionRuleId,
                    payload
                );

            if (response.success) {
                dispatch(
                    updateCommissionRuleSuccess(
                        response.data
                    )
                );

                return response;
            }

            dispatch(
                updateCommissionRuleFailure(
                    response.error
                )
            );

            return response;
        } catch (error) {
            dispatch(
                updateCommissionRuleFailure(
                    error.message
                )
            );

            return {
                success: false,
                error: error.message,
            };
        }
    };



export const deleteCommissionRuleRequest = () => ({
    type: DELETE_COMMISSION_RULE_REQUEST,
});

export const deleteCommissionRuleSuccess = (
    commissionRuleId
) => ({
    type: DELETE_COMMISSION_RULE_SUCCESS,
    payload: commissionRuleId,
});

export const deleteCommissionRuleFailure = (
    error
) => ({
    type: DELETE_COMMISSION_RULE_FAILURE,
    payload: error,
});

export const deleteCommissionRuleAction =
    (commissionRuleId) =>
    async (dispatch) => {
        dispatch(
            deleteCommissionRuleRequest()
        );

        try {
            const response =
                await deleteCommissionRule(
                    commissionRuleId
                );

            if (response.success) {
                dispatch(
                    deleteCommissionRuleSuccess(
                        commissionRuleId
                    )
                );

                return response;
            }

            dispatch(
                deleteCommissionRuleFailure(
                    response.error
                )
            );

            return response;
        } catch (error) {
            dispatch(
                deleteCommissionRuleFailure(
                    error.message
                )
            );

            return {
                success: false,
                error: error.message,
            };
        }
    };